import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme, Button, injectKeyframes, useTranslationTyped } from '@kantera/ui';

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslationTyped();

  useEffect(() => {
    document.title = t('webNotFound.pageTitle');
    injectKeyframes();
  }, [t]);

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 24px',
        background: theme.colors.bg.primary,
        animation: 'kFadeIn 300ms ease-out',
      }}
    >
      <div
        style={{
          maxWidth: '500px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        {/* 404 Number */}
        <div
          style={{
            fontSize: '96px',
            fontWeight: 800,
            color: theme.colors.accent.primary,
            margin: '0 0 16px',
            letterSpacing: '-0.02em',
            opacity: 0.9,
          }}
        >
          404
        </div>

        {/* Title */}
        <h1
          style={{
            fontSize: '28px',
            fontWeight: 800,
            color: theme.colors.text.primary,
            margin: '0 0 12px',
            letterSpacing: '-0.02em',
          }}
        >
          {t('webNotFound.title')}
        </h1>

        {/* Description */}
        <p
          style={{
            fontSize: '16px',
            color: theme.colors.text.secondary,
            margin: '0 0 32px',
            lineHeight: 1.6,
          }}
        >
          {t('webNotFound.body')}
        </p>

        {/* CTA Button */}
        <Button
          onClick={() => navigate('/')}
          style={{
            paddingLeft: '24px',
            paddingRight: '24px',
          }}
          aria-label={t('webNotFound.btnBackToDashboard')}
        >
          {t('webNotFound.btnBackToDashboard')}
        </Button>

        {/* Subtle background decoration */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            zIndex: -1,
            background: `radial-gradient(circle at 50% 50%, rgba(129,140,248,0.03) 0%, transparent 70%)`,
          }}
        />
      </div>
    </div>
  );
};

export default NotFound;
